module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"subtitle":"Pipeline: {name}","invalidStage":"Invalid stage","invalidPipeline":"Invalid pipeline"}}')
  delete Component.options._Ctor
}
